
type Props = {
  fillColor?: string,
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#7E7E7E',
};
const ExportIcon = function ExportIcon(props: Props) {
  const { fillColor } = props;
  return (
    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg" className='export-icon-sg'>
      <path d="M10.1893 4.08255L11.7192 5.57133L4.96845 5.57133C4.43218 5.57133 4.00631 5.98574 4.00631 6.50758C4.00631 7.02942 4.43218 7.44383 4.96845 7.44383L11.735 7.44383L10.205 8.93261C10.0158 9.11679 9.92114 9.34701 9.92114 9.59259C9.92114 9.83816 10.0158 10.0684 10.205 10.2526C10.5836 10.6209 11.183 10.6209 11.5615 10.2526L14.7161 7.16756C15.0946 6.7992 15.0946 6.21596 14.7161 5.8476L11.5457 2.7626C11.1672 2.39424 10.5678 2.39424 10.1893 2.7626C9.81073 3.13096 9.81073 3.71419 10.1893 4.08255Z" fill={fillColor} />
      <path d="M5.48896 12.0638C5.48896 11.5419 5.06309 11.1275 4.52682 11.1275H1.92429L1.92429 1.87249L4.52682 1.87249C5.06309 1.87249 5.48896 1.45809 5.48896 0.936246C5.48896 0.414404 5.06309 0 4.52682 0L0.962146 0C0.425869 0 1.43051e-06 0.414404 1.43051e-06 0.936246L1.43051e-06 12.0638C1.43051e-06 12.5856 0.425869 13 0.962146 13H4.52682C5.06309 13 5.48896 12.5856 5.48896 12.0638Z" fill={fillColor} />
    </svg>

  );
};
ExportIcon.defaultProps = defaultProps;
export default ExportIcon;